import { THROW_ERROR, DISMISS_ERROR } from '../constants';

const INITIAL_STATE = null;

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case THROW_ERROR:
      return { ...state, ...payload };
    case DISMISS_ERROR:
      return null;
    default:
      return state;
  }
};
